module.exports = __webpack_public_path__ + "img/c5.e64bdb43.webp";